import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import { paginate } from "../../../utlits/Paginate.js";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import Pagination from "../../Reuseable/Pagination";
import DataParser from "../../../utlits/Dataparser";
import ForceCheckoutTimeServices from "../../../Services/ForceCheckoutTimeService";
import secureLocalStorage from "react-secure-storage";

const ForceCheckoutTime = () => {
    const [ForceCheckoutTimeList, setForceCheckoutTimeList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [userPermissions, setuserPermissions] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [forceCheckoutTime, setForceCheckoutTime] = useState("");
    const [forceCheckoutTimeEdit, setForceCheckoutTimeEdit] = useState("");
    const [itemToDelete, setItemToDelete] = useState(null);
    const [editID, setEditID] = useState("");
    const companyId = DataParser.CompanyId();

    const navigate = useNavigate();

    const getData = () => {
        setLoading(true);
        ForceCheckoutTimeServices.getForceCheckoutTime(companyId)
            .then((res) => {
                if (res.data === "Un-Athunticated request") {
                    secureLocalStorage.removeItem("adminInfo");
                    secureLocalStorage.removeItem("admins");
                    navigate("/");
                    return;
                }
                const data = res.data.force_checkout_time;
                setForceCheckoutTimeList(data);
            })
            .catch((err) => {
                console.error("Error fetching force checkout time:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handelPageChange = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
    };

    useEffect(() => {
        if (pageSize > 15) {
            setCurrentPage(1);
        }
    }, [pageSize]);

    const handelSubmit = (e) => {
        e.preventDefault();

        if (!forceCheckoutTime || forceCheckoutTime.trim() === "") {
            setError("Force Checkout Hours is required!");
            return;
        }
        if (isNaN(forceCheckoutTime) || Number(forceCheckoutTime) <= 0) {
            setError("Please enter a valid number of hours (minimum 0.01).");
            return;
        }

        const AddData = {
            force_checkout_time: forceCheckoutTime.trim(),
            company_id: companyId,
        };

        ForceCheckoutTimeServices.createForceCheckoutTime(AddData)
            .then((res) => {
                if (res.data === "Un-Athunticated request") {
                    secureLocalStorage.removeItem("adminInfo");
                    secureLocalStorage.removeItem("admins");
                    navigate("/");
                    return;
                }

                if (res.Good === true) {
                    message.success("Force Checkout Time added successfully!");
                    const link = document.getElementById("ModalCreateClose");
                    if (link) link.click();
                    getData();
                    setForceCheckoutTime("");
                    setError("");
                } else {
                    message.warning(res.data || "Failed to add force checkout time. Please try again!");
                }
            })
            .catch((err) => {
                console.error("Error creating force checkout time:", err);
                message.error(
                    err.response?.data?.message ||
                    "An unexpected error occurred while creating the force checkout time."
                );
            });
    };

    useEffect(() => {
        getData();
        const upermission = DataParser.CompanyUserPermissions();
        setuserPermissions(upermission || []);
    }, [companyId]);

    const handelOpenUpdate = (e, item) => {
        e.preventDefault();
        setForceCheckoutTimeEdit(item.force_checkout_time);
        setEditID(item.id);
        setError("");
    };

    const handelEditSubmit = (e) => {
        e.preventDefault();

        if (!forceCheckoutTimeEdit || forceCheckoutTimeEdit.trim() === "") {
            setError("Force Checkout Hours is required!");
            return;
        }
        if (isNaN(forceCheckoutTimeEdit) || Number(forceCheckoutTimeEdit) <= 0) {
            setError("Please enter a valid number of hours (minimum 0.01).");
            return;
        }

        const AddData = {
            force_checkout_time: forceCheckoutTimeEdit.trim(),
        };

        ForceCheckoutTimeServices.editForceCheckoutTime(editID, AddData)
            .then((res) => {
                if (res.data === "Un-Athunticated request") {
                    secureLocalStorage.removeItem("adminInfo");
                    secureLocalStorage.removeItem("admins");
                    navigate("/");
                    return;
                }

                if (res.Good === true) {
                    message.success("Force Checkout Time updated successfully!");
                    const link = document.getElementById("ModalEditClose");
                    if (link) link.click();
                    getData();
                    setError("");
                } else {
                    message.warning(res.data || "Failed to update force checkout time. Please try again!");
                }
            })
            .catch((err) => {
                console.error("Error updating force checkout time:", err);
                message.error(
                    err.response?.data?.message ||
                    "An unexpected error occurred while updating the force checkout time."
                );
            });
    };

    const handelDelete = (e, item) => {
        e.preventDefault();
        setItemToDelete(item);
        const trigger = document.getElementById("openDeleteModalTrigger");
        if (trigger) trigger.click();
    };

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        const id = itemToDelete.id;
        
        // Optimistic UI update
        const newData = ForceCheckoutTimeList.filter((el) => el.id !== id);
        setForceCheckoutTimeList(newData);
        
        const closeBtn = document.getElementById("closeDeleteModal");
        if (closeBtn) closeBtn.click();

        try {
            const res = await ForceCheckoutTimeServices.deleteForceCheckoutTime(id, companyId);
            if (res && res.data === "Un-Athunticated request") {
                secureLocalStorage.removeItem("adminInfo");
                secureLocalStorage.removeItem("admins");
                navigate("/");
            } else if (res && res.Good) {
                message.success("Force Checkout Time deleted successfully!");
            } else {
                message.error(res?.data || "Failed to delete force checkout time. Please try again!");
            }
            getData();
        } catch (err) {
            console.error("Delete error:", err);
            message.error("Failed to delete force checkout time. Please try again!");
            getData();
        }
        setItemToDelete(null);
    };

    const PaginatedData = paginate(ForceCheckoutTimeList, currentPage, pageSize);

    return (
        <>
            <Helmet>
                <title>Force Checkout Time - Planit</title>
            </Helmet>
            <div className="main-content">
                <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                                    <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                                        <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item">
                                                <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                                            </li>
                                            <li className="breadcrumb-item active">Force Checkout Hours</li>
                                        </ol>

                                        {(ForceCheckoutTimeList.length === 0 && userPermissions.indexOf("force-checkout-time-create") !== -1) && (
                                            <button
                                                className="btn btn-primary waves-effect waves-light"
                                                style={{ borderRadius: "5px" }}
                                                data-bs-toggle="modal"
                                                data-bs-target="#createModal"
                                            >
                                                Add Force Checkout Hours
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12 px-0">
                                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                                    <div className="card-body p-0">
                                        <div className="table-responsive listing-table-wrapper">
                                            <table className="table mb-0 custom-table listing-table">
                                                <thead>
                                                    <tr className="tableHeaderbg">
                                                        <th>Sr#</th>
                                                        <th>Force Checkout Hours</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <TableSkeleton cols={3} rows={6} />
                                                    ) : (
                                                        <>
                                                            {PaginatedData && PaginatedData.length > 0 ? (
                                                                PaginatedData.map((item, index) => (
                                                                    <tr key={item.id}>
                                                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                                                        <td>{item.force_checkout_time} Hours</td>
                                                                        <td className="tableset">
                                                                            {userPermissions.indexOf("force-checkout-time-delete") !== -1 ? (
                                                                                <Link
                                                                                    to="#"
                                                                                    className="cursor-pointer iconscolor"
                                                                                    onClick={(e) => handelDelete(e, item)}
                                                                                >
                                                                                    <Tooltip title="Delete Force Checkout Time">
                                                                                        <i className="uil-trash iconscolor" />
                                                                                    </Tooltip>
                                                                                </Link>
                                                                            ) : (
                                                                                <span
                                                                                    className="uil-trash iconscolor text-muted"
                                                                                    style={{ cursor: "not-allowed", opacity: 0.5 }}
                                                                                    title="You don't have permission to delete"
                                                                                />
                                                                            )}
                                                                            {userPermissions.indexOf("force-checkout-time-edit") !== -1 ? (
                                                                                <Link
                                                                                    to="#"
                                                                                    className="cursor-pointer iconscolor"
                                                                                    onClick={(e) => handelOpenUpdate(e, item)}
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#updateModal"
                                                                                >
                                                                                    <Tooltip title="Edit Force Checkout Time">
                                                                                        <i className="uil-pen iconscolor" />
                                                                                    </Tooltip>
                                                                                </Link>
                                                                            ) : (
                                                                                <span
                                                                                    className="uil-pen iconscolor text-muted"
                                                                                    style={{ cursor: "not-allowed", opacity: 0.5 }}
                                                                                    title="You don't have permission to edit"
                                                                                />
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="3" className="text-center">No records found.</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>

                                            {ForceCheckoutTimeList.length > pageSize && (
                                                <div className="d-flex justify-content-center mt-4">
                                                    <Pagination
                                                        itemCount={ForceCheckoutTimeList.length}
                                                        currentPage={currentPage}
                                                        pageSize={pageSize}
                                                        onPageChange={handelPageChange}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Hidden trigger for delete modal */}
                    <div id="openDeleteModalTrigger" data-bs-toggle="modal" data-bs-target="#deleteSessionModal" style={{ display: "none" }} />

                    {/* Delete Confirmation Modal */}
                    <div id="deleteSessionModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
                        <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
                            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                                <div className="modal-header border-0 pb-1">
                                    <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Force Checkout Time</h5>
                                    <button type="button" className="btn-close" id="closeDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
                                </div>
                                <div className="modal-body pt-2 pb-2">
                                    <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this force checkout time?</p>
                                    <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                                        <i className="uil uil-exclamation-triangle me-1" />
                                        This action cannot be undone.
                                    </p>
                                </div>
                                <div className="modal-footer border-0 pt-1">
                                    <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                {/* Create modal content */}
                <div
                    id="createModal"
                    className="modal fade"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="createModalLabel"
                    aria-hidden="true"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
                        <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                            <div className="modal-header border-0 pb-1">
                                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Add Force Checkout Hours</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    id="ModalCreateClose"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body pt-2 pb-2">
                                <div className="float-input-wrap">
                                    <input
                                        type="number"
                                        min="0.01"
                                        step="0.01"
                                        className={error ? "is-invalid" : ""}
                                        placeholder=" "
                                        value={forceCheckoutTime}
                                        onChange={(e) => {
                                            setForceCheckoutTime(e.target.value);
                                            if (e.target.value.trim() !== "") setError("");
                                        }}
                                    />
                                    <label>Force Checkout Hours*</label>
                                </div>
                                {error && <small className="text-danger mt-1 d-block">{error}</small>}
                            </div>
                            <div className="modal-footer border-0 pt-1">
                                <button
                                    onClick={(e) => handelSubmit(e)}
                                    type="button"
                                    className="btn btn-primary waves-effect waves-light"
                                    style={{ borderRadius: "5px", fontSize: "13px" }}
                                >
                                    + Add Force Checkout Hours
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Edit modal content */}
                <div
                    id="updateModal"
                    className="modal fade"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="updateModalLabel"
                    aria-hidden="true"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
                        <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                            <div className="modal-header border-0 pb-1">
                                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Force Checkout Hours</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    id="ModalEditClose"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body pt-2 pb-2">
                                <div className="float-input-wrap">
                                    <input
                                        type="number"
                                        min="0.01"
                                        step="0.01"
                                        className={error ? "is-invalid" : ""}
                                        placeholder=" "
                                        value={forceCheckoutTimeEdit}
                                        onChange={(e) => {
                                            setForceCheckoutTimeEdit(e.target.value);
                                            if (e.target.value.trim() !== "") setError("");
                                        }}
                                    />
                                    <label>Force Checkout Hours*</label>
                                </div>
                                {error && <small className="text-danger mt-1 d-block">{error}</small>}
                            </div>
                            <div className="modal-footer border-0 pt-1">
                                <button
                                    type="button"
                                    onClick={(e) => handelEditSubmit(e)}
                                    className="btn btn-primary waves-effect waves-light"
                                    style={{ borderRadius: "5px", fontSize: "13px" }}
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
);
};

export default ForceCheckoutTime;
